export default __webpack_public_path__ + "locales/nl/BackupCodesDialog.json?hash=6f87b5de28262f2a8ea4632dac6d2fb9";